export default {
  buttons: {
    back: 'Atrás',
  },
};
